import { render, staticRenderFns } from "./activityBridge.vue?vue&type=template&id=13a1b30c"
import script from "./activityBridge.vue?vue&type=script&lang=js"
export * from "./activityBridge.vue?vue&type=script&lang=js"
import style0 from "./activityBridge.vue?vue&type=style&index=0&id=13a1b30c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports